export default __webpack_public_path__ + "img/g101.53f3c004.png";